import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import * as docketActions from '../../../../redux/actions/docketActions';
import EmailCombinedPdfPopup from './EmailCombinedPdfPopup';
import AllPartsPrintPreview from './AllPartsPrintPreview';
import DownloadZipAllPdfsRangePopup from './DownloadZipAllPdfsRangePopup';
import DownloadZipWithSubpartsPopup from './DownloadZipWithSubpartsPopup';
import DownloadCombineAllPdfInRangePopup from './DownloadCombineAllPdfInRangePopup';
import PrintAllPdfInRangePopup from './PrintAllPdfInRangePopup';
import EmailPartPopup from './EmailPartPopup';
import EmailPartModal from './EmailPartModal/EmailPartModal';
import EmailAllPartsZipPopup from './EmailAllPartsZipPopup';

const DocketPopup = ({ onPopupClick, popup, reloadDetails }) => {
  const popupForm = {
    EmailCombinedPdfPopup,
    AllPartsPrintPreview,
    DownloadZipAllPdfsRangePopup,
    DownloadZipWithSubpartsPopup,
    DownloadCombineAllPdfInRangePopup,
    PrintAllPdfInRangePopup,
    EmailPartPopup,
    EmailPartModal,
    EmailAllPartsZipPopup,
  };
  const DocketsPopupComponentType = popup.show && popupForm[popup.name];

  return (
    DocketsPopupComponentType && (
      <DocketsPopupComponentType onClose={onPopupClick} info={popup} reloadDetails={reloadDetails} />
    )
  );
};

DocketPopup.propTypes = {
  popup: PropTypes.object.isRequired,
  reloadDetails: PropTypes.func,
};

DocketPopup.defaultProps = {
  reloadDetails: () => {},
};
const mapStateToProps = state => {
  const { popup } = state.get('dockets').toJS();

  return {
    popup,
  };
};

const mapDispatchToProps = {
  onPopupClick: docketActions.togglePopup,
};

export default connect(mapStateToProps, mapDispatchToProps)(DocketPopup);



// WEBPACK FOOTER //
// ./src/components/case/docket/popups/DocketPopup.jsx